import { CustomPopover } from '@aibees/shared/components';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(CustomPopover)`
  /* width: p => p.spacing(80); */
  .MuiPopover-paper {
    border: 1px solid ${(p) => p.theme.palette.primary[100]};
    border-radius: ${(p) => p.theme.spacing(2)};
    box-shadow: 0px 4px 6px -2px rgba(10, 13, 18, 0.031),
      0px 12px 16px -4px rgba(10, 13, 18, 0.078);
  }
`;
